<template>
  <div class="layout-left-menu">
    <div class="head">
      <div class="logo"><img src="@/assets/images/logo.png" @click="redirect('/feature')" />
      </div>
      <!-- <div class="head-btn">
        <el-button type="primary" icon="el-icon-position" class="menu-btn" @click="redirect('/')">AI Chat
        </el-button>
      </div> -->
    </div>
    <div class="menu">
      <div class="menu-item" v-for="(item,index) in secondLevelMenus" :key="index">
        <div class="parent-menu">{{ item.meta.title }}</div>
        <div class="children-menu" v-if="item.children && item.children.length">
          <div v-for="(children,idx) in item.children" :key="idx"
            @click="toChildrenPath(children)" :class="['item', {
              'item-active': isRouteActive(children)
            }]"><i :class="children.meta.icon"></i>{{ children.meta.title
            }}
          </div>
        </div>
      </div>
    </div>
    <div class="user-btn">
      <el-dropdown trigger="click" @command="handleCommand">
        <div class="user-info">
          <el-avatar size="small"> {{ avatarText }} </el-avatar>
          <span style="margin:0px 8px;font-size:16px">{{ userInfo.name }}</span>
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="home">个人中心</el-dropdown-item>
          <el-dropdown-item command="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'MenuItem',
  props: ['routes'],
  computed: {
    ...mapGetters(['currentFirstLevelMenu']),
    avatarText() {
      return this.getAvatarText(this.userInfo.name)
    },
    secondLevelMenus() {
      // 如果有当前选中的一级菜单，则显示该菜单下的二级菜单
      if (this.currentFirstLevelMenu && this.currentFirstLevelMenu.children) {
        // 过滤掉隐藏的菜单项
        return this.filterTree(this.currentFirstLevelMenu.children);
      }
      
      // 否则尝试根据当前路由路径找到对应的一级菜单下的二级菜单
      let nowPath = this.$router.currentRoute.path;
      let secondLevelMenus = [];
      
      // 处理二维数组的情况
      if (Array.isArray(this.$router.options.adminRoutes)) {
        this.$router.options.adminRoutes.forEach(routeGroup => {
          if (Array.isArray(routeGroup)) {
            // 如果是二维数组，遍历每个子数组
            routeGroup.forEach(route => {
              if (nowPath === route.path || this.isChildRoute(nowPath, route)) {
                if (route.children) {
                  secondLevelMenus = [...secondLevelMenus, ...route.children];
                }
              }
            });
          } else {
            // 兼容处理一维数组的情况
            if (nowPath === routeGroup.path || this.isChildRoute(nowPath, routeGroup)) {
              if (routeGroup.children) {
                secondLevelMenus = [...secondLevelMenus, ...routeGroup.children];
              }
            }
          }
        });
      }
      
      return this.filterTree(secondLevelMenus);
    },
    avatarText() {
      return this.getAvatarText(this.userInfo.name)
    }
  },
  watch: {
    // 监听路由变化，可能需要更新菜单项
    '$route': {
      handler: function(to) {
        // 路由变化时，如果没有当前选中的一级菜单，可能需要重新计算
        if (!this.currentFirstLevelMenu) {
          // 这里不需要额外操作，因为 secondLevelMenus 计算属性会自动重新计算
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      userInfo: this.$store.getters['user/userInfo']
    }
  },
  methods: {
    // 检查当前路径是否是某个路由的子路由
    isChildRoute(currentPath, route) {
      if (!route.children) return false;
      
      // 检查是否是直接子路由
      const directChild = route.children.some(child => 
        currentPath === child.path || currentPath.startsWith(child.path + '/')
      );
      if (directChild) return true;
      
      // 递归检查更深层次的子路由
      return route.children.some(child => this.isChildRoute(currentPath, child));
    },
    // 检查路由是否处于激活状态（包括多层级子路由）
    isRouteActive(route) {
      const currentPath = this.$route.path;
      // 1. 完全匹配
      if (currentPath === route.path) {
        return true;
      }

      //2.查询父级
      if(this.$route.matched.length > 1) {
        const parentRoute = this.$route.matched[this.$route.matched.length - 2];
        if (parentRoute.path === route.path) {
          return true;
        }
      }
      
      return false;
    },
    filterTree(tree) {
      return tree
          .filter(item => !item.meta?.hidden)
          .map(item => {
            const filteredChildren = item.children ? this.filterTree(item.children) : [];
            return {
              ...item,
              children: filteredChildren
            };
          });
    },
    redirect(path) {
        // 判断是否为外部链接
        // 使用 store 中的 action 查找并设置一级菜单
        this.$store.dispatch('findAndSetFirstLevelMenu', {
          path,
          router: this.$router
        });
        
        // 路由跳转
        this.$router.push(path);
    },
    toChildrenPath(row) {
      if(row.children && row.children.length > 0) {
        const firstVisibleChild = row.children.find(child => !child.meta?.hidden);
        let path = '';
        if (firstVisibleChild) {
          path = firstVisibleChild.path;
        }else{
          path = row.children[0].path;
        }
        if (path && path.includes('http')) {
          window.open(path, '_blank');
          return;
        }
        this.$router.push(path);
      } else {
        if (row.redirect && row.redirect.includes('http')) {
          window.open(row.redirect, '_blank');
          return;
        }
        this.$router.push(row.redirect || row.path);
      }
    },
    getAvatarText(name) {
      if (!name) return '';
      
      // Remove any whitespace
      const cleanName = name.trim();
      
      // For two-character names, return both characters
      if (cleanName.length === 2) {
        return cleanName;
      }
      
      // For names with 3 or more characters, return the last two
      if (cleanName.length >= 3) {
        return cleanName.slice(-2);
      }
      
      // For single character names, just return that character
      return cleanName;
    },
    handleCommand(command) {
      if (command === 'logout') {
        this.handleLogout();
      }
      if (command === 'home') {
        this.$router.push('/chat/index')
      }
    },
    handleLogout() {
      // 调用退出登录的方法，具体实现可能需要调用 store action
      this.$store.dispatch('user/logout').then(() => {
        this.$router.push('/login')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.layout-left-menu {
  height: 100%;
  width: 200px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  //border-right: 1px solid #eaeaea;
  background:#F4F6F9;
  box-sizing: border-box;
  ::v-deep(.el-dropdown) {
    font-size: 16px;
  }
  .head {
    margin-top:5px;
    .logo {
      width: 160px;
      cursor: pointer;

      img {
        width: 100%;
      }
    }

    .head-btn {
      width: 100%;

      .menu-btn {
        width: 100%;
        background: linear-gradient(111deg, #654CFF 0%, #007FFF 99%);
        border-radius: 10px;
      }
    }
  }

  .menu {
    flex: 1;
    overflow-y: auto;
    padding:0px 15px;
    margin:25px 0px;
    .menu-item {
      text-align: left;
      // margin-top: 10px;

      .parent-menu {
        color: #848691;
        font-size: 14px;
        // margin-bottom: 12px;
        padding-left: 12px;
        margin:15px 0px;
        // border-top: 1px solid #ECEEF3;
      }

      .children-menu {
        color: #3F3E62;
        font-size: 15px;

        .item {
          padding: 10px;
          display: flex;
          align-items: center;
          cursor: pointer;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          gap: 10px;
          margin-bottom: 5px;

          i {
            font-size: 16px;
          }
        }

        .item:hover {
          background: #f5f5f5;
          border-radius: 10px;
        }
        .item-active {
          border-radius: 10px;
          background: #DDE9FA;
          color: #1677FF;
        }
      }
    }
  }

  .user-btn {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px;
    justify-content: center;
    padding-right: 40px;

    .user-info {
      display: flex;
      align-items: center;
      cursor: pointer;

      ::v-deep .el-avatar{
        background: #168CFF;
      }

      .el-icon-caret-bottom {
        margin-left: 4px;
        font-size: 12px;
      }
    }
  }
}
</style>
